import { useEffect } from "react";

const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null; // hoặc return 1 loading spinner trong lúc chờ redirect
};

export default ExternalRedirect;